"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.overlayPropType = exports.linkPropType = exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var overlayPropType = _propTypes["default"].shape({
  text: _propTypes["default"].string,
  title: _propTypes["default"].string
});
exports.overlayPropType = overlayPropType;
var linkPropType = _propTypes["default"].shape({
  ctaType: _propTypes["default"].string,
  label: _propTypes["default"].string,
  priority: _propTypes["default"].string,
  url: _propTypes["default"].string
});
exports.linkPropType = linkPropType;
var PROP_TYPES = _propTypes["default"].shape({
  links: _propTypes["default"].arrayOf(linkPropType),
  overlayCopy: overlayPropType
});
var _default = PROP_TYPES;
exports["default"] = _default;